const data = [
  {
    name: "Menu",
    path: null,
    children: [
      { name: "Visão Geral", icon: "mdi-home", route: "/home", path: null},
      { name: "Residências", icon: "mdi-home-city-outline", route: "/operacao/residencias", path: null },
      { name: "Comércio", icon: "mdi-storefront-outline", route: "/operacao/comercio", path: null },
      { name: "Núcleos", icon: "mdi-map-marker-multiple-outline", route: "/nucleos", path: null },
      { name: "Chamados", icon: "mdi-clipboard-text-outline", route: "/demandas", path: null },
      {
        name: "Financeiro",
        icon: "mdi-finance",
        route: "/financeiro",
        path: null,
        children: [
          { name: "Mensalidades", icon: "mdi-barcode", route: "/financeiro", path: null },
          { name: "Prestação", icon: "mdi-cash-check", route: "/financeiro/prestacao", path: null },
          { name: "Contas", icon: "mdi-bank-outline", route: "/financeiro/contas", path: null },
          { name: "Fluxo de caixa", icon: "mdi-cash-sync", route: "/financeiro/fluxo-de-caixa", path: null },
          { name: "Extratos", icon: "mdi-file-upload-outline", route: "/financeiro/extratos", path: null },
          { name: "Repasses", icon: "mdi-bank-transfer-out", route: "/financeiro/repasses", path: null },
        ],
      },
      { name: "Administradores", icon: "mdi-account-tie-outline", route: "/administradores", path: null },
      {
        name: "Operação",
        icon: "mdi-view-dashboard-edit-outline",
        route: "/operacao/prioridades",
        path: null,
        children: [
          { name: "Prioridades", icon: "mdi-format-list-checks", route: "/operacao/prioridades", path: null },
          { name: "Mapa", icon: "mdi-map-marker-radius-outline", route: "/operacao/mapa", path: null },
          { name: "Coleta", icon: "mdi-trash-can-outline", route: "/operacao/coleta", path: null },
          { name: "Emergência", icon: "mdi-phone-alert-outline", route: "/operacao/emergencia", path: null },
          { name: "Rondas", icon: "mdi-shield-check-outline", route: "/operacao/rondas", path: null },
          { name: "Votações", icon: "mdi-poll", route: "/operacao/votacoes", path: null },
          { name: "Relatórios", icon: "mdi-file-chart-outline", route: "/operacao/relatorios", path: null },
        ],
      },
      {
        name: "Segurança",
        icon: "mdi-shield-alert-outline",
        route: "/seguranca/central",
        path: null,
        children: [
          { name: "Central", icon: "mdi-shield-home-outline", route: "/seguranca/central", path: null },
          { name: "Território", icon: "mdi-map-marker-path", route: "/seguranca/territorio", path: null },
          { name: "Equipes", icon: "mdi-account-hard-hat-outline", route: "/seguranca/equipes", path: null },
        ],
      },
      {
        name: "Portaria",
        icon: "mdi-gate",
        route: "/portaria/autorizacoes",
        path: null,
        children: [
          { name: "Autorizações", icon: "mdi-account-check-outline", route: "/portaria/autorizacoes", path: null },
          { name: "Encomendas", icon: "mdi-package-variant-closed", route: "/portaria/encomendas", path: null },
          { name: "Portarias", icon: "mdi-gate", route: "/portaria/portarias", path: null },
        ],
      },
      {
        name: "Configurações",
        icon: "mdi-cog-outline",
        route: "/configuracoes/pagamentos",
        path: null,
        children: [
          { name: "Pagamentos", icon: "mdi-credit-card-outline", route: "/configuracoes/pagamentos", path: null },
          { name: "Conta", icon: "mdi-account-circle-outline", route: "/configuracoes/conta", path: null },
          { name: "Planos", icon: "mdi-crown-outline", route: "/configuracoes/planos", path: null },
          { name: "Visual", icon: "mdi-palette-outline", route: "/configuracoes/visual", path: null },
        ],
      },
      { name: "Suporte", icon: "mdi-lifebuoy", route: "/suporte", path: null },
      { name: "Assembleias", icon: "mdi-account-voice", route: "/assembleias", path: null },
      { name: "Feed", icon: "mdi-newspaper-variant-outline", route: "/feed", path: null },
    ],
  },
];

export default [...data];
